import React, {FC, useEffect, useState} from 'react';

import {useEventHandler} from '../../../libs/shared/core/src/helpers/react/hooks/useEventHandler';
import {DataEventActionsEnum} from '../../../libs/shared/core/src/models/tracking/dataEventActions';
import {AppDataEventObject} from '../../../libs/shared/core/src/models/tracking/objectNames/appDataEventObject';
import {useDataEventTracking} from '../../../libs/shared/core/src/services/tracking/dataEventTrackingContext';
import {getHasPolicyViolationWarning} from '../../../libs/shared/core/src/store/featureFlags/featureFlagsSelectors';
import {useAppSelector} from '../../helpers/appReduxHelpers';
import {PolicyViolationWarningTip} from './policyViolationWarningTip';

/*
 * Props.
 */

interface PolicyViolationWarningTipContainerProps {}

/*
 * Component.
 */

export const PolicyViolationWarningTipContainer: FC<PolicyViolationWarningTipContainerProps> = () => {
  const hasPolicyViolationWarning = useAppSelector(getHasPolicyViolationWarning);
  // This banner cannot be permanently dismissed, only temporarily.
  const [isDismissed, setIsDismissed] = useState(false);
  const isVisible = hasPolicyViolationWarning && !isDismissed;

  // TODO: De-dupe with GlgIndividualRuleWarningTipContainer.
  const {trackDataEvent} = useDataEventTracking();
  const onView = useEventHandler(() => {
    trackDataEvent(DataEventActionsEnum.VIEW, AppDataEventObject.POLICY_VIOLATION_WARNING);
  });

  useEffect(() => {
    if (isVisible) {
      onView();
    }
  }, [isVisible, onView]);

  if (!isVisible) {
    return null;
  }

  const onDismiss = () => {
    setIsDismissed(true);
    trackDataEvent(DataEventActionsEnum.CLOSE, AppDataEventObject.POLICY_VIOLATION_WARNING);
  };

  return <PolicyViolationWarningTip onDismiss={onDismiss} />;
};
